import { render, staticRenderFns } from "./AllowCameraComponent.vue?vue&type=template&id=9c096e8e"
import script from "./AllowCameraComponent.vue?vue&type=script&lang=js"
export * from "./AllowCameraComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports